var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "app" } }, [
    _c("header"),
    _vm._v(" "),
    _c("main", [
      _c(
        "div",
        [
          _c(
            "b-navbar",
            { attrs: { type: "light", variant: "light" } },
            [
              _c(
                "b-navbar-brand",
                { attrs: { href: "#" } },
                [
                  _vm.isUser
                    ? _c(
                        "router-link",
                        {
                          staticClass: "my-0 mr-md-auto font-weight-normal",
                          attrs: { to: "/signedin" },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: `logo.png`,
                              alt: "",
                              width: "72",
                              height: "72",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isCompany
                    ? _c(
                        "router-link",
                        {
                          staticClass: "my-0 mr-md-auto font-weight-normal",
                          attrs: { to: "/companyhome" },
                        },
                        [
                          _vm.isCompany
                            ? _c("fa", {
                                staticClass: "fa-3x",
                                staticStyle: { color: "#bc0101" },
                                attrs: { icon: "building" },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isLoggedIn
                    ? _c(
                        "router-link",
                        {
                          staticClass: "my-0 mr-md-auto font-weight-normal",
                          attrs: { to: "/" },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: `logo.png`,
                              alt: "",
                              width: "72",
                              height: "72",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-item",
                    { staticClass: "ml-3" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "text-dark",
                          staticStyle: { cursor: "pointer" },
                          attrs: { to: "/information" },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "fa-2x",
                            staticStyle: { color: "#198fcf" },
                            attrs: { icon: "fa-solid fa-circle-info" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isUser
                    ? _c("b-nav-item", { staticClass: "ml-3" }, [
                        _vm.isLoggedIn
                          ? _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.feedback",
                                    modifiers: { feedback: true },
                                  },
                                ],
                                staticClass: "text-dark",
                                staticStyle: { cursor: "pointer" },
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "fa-2x",
                                  staticStyle: { color: "#198fcf" },
                                  attrs: { icon: "fa-solid fa-comment-smile" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isUser
                    ? _c(
                        "b-nav-item",
                        { staticClass: "ml-3" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "text-dark",
                              staticStyle: { cursor: "pointer" },
                              attrs: { to: "/signedin" },
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "fa-2x",
                                staticStyle: { color: "#198fcf" },
                                attrs: {
                                  icon: "fa-solid fa-up-from-bracket",
                                  id: "thumbToMainMenue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isUser
                    ? _c("b-nav-item", { staticClass: "ml-3" }, [
                        _c(
                          "a",
                          {
                            staticClass: "text-dark",
                            staticStyle: { cursor: "pointer" },
                            attrs: { id: "thumbLogOut" },
                            on: {
                              click: function ($event) {
                                return _vm.logout()
                              },
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "fa-2x",
                              staticStyle: { color: "#198fcf" },
                              attrs: { icon: "fa-solid fa-right-from-bracket" },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    [
                      _c(
                        "b-modal",
                        {
                          attrs: {
                            id: "feedback",
                            title: "Zeit für ein kurzes Feedback",
                            "hide-footer": "",
                          },
                          model: {
                            value: _vm.modalShow,
                            callback: function ($$v) {
                              _vm.modalShow = $$v
                            },
                            expression: "modalShow",
                          },
                        },
                        [
                          _c("div", { staticClass: "row p-3" }, [
                            _vm._v("Wie zufrieden bist du mit der Seite?"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col text-center m-3" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col text-center m-3",
                                staticStyle: { cursor: "pointer" },
                              },
                              [
                                _vm.feedbackThumpUpActive
                                  ? _c("font-awesome-icon", {
                                      staticClass: "fa-3x",
                                      staticStyle: { color: "#198fcf" },
                                      attrs: { icon: "fa-solid fa-thumbs-up" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.ToggleThump("thumpUp")
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.feedbackThumpUpActive
                                  ? _c("font-awesome-icon", {
                                      staticClass: "fa-3x",
                                      staticStyle: { color: "#198fcf" },
                                      attrs: {
                                        icon: "fa-regular fa-thumbs-up",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.ToggleThump("thumpUp")
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col text-center m-3",
                                staticStyle: { cursor: "pointer" },
                              },
                              [
                                _vm.feedbackThunpDownActive
                                  ? _c("font-awesome-icon", {
                                      staticClass: "fa-3x",
                                      staticStyle: { color: "#198fcf" },
                                      attrs: {
                                        icon: "fa-solid fa-thumbs-down",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.ToggleThump("thumpDown")
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.feedbackThunpDownActive
                                  ? _c("font-awesome-icon", {
                                      staticClass: "fa-3x",
                                      staticStyle: { color: "#198fcf" },
                                      attrs: {
                                        icon: "fa-regular fa-thumbs-down",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.ToggleThump("thumpDown")
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col text-center m-3" }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row p-3" }, [
                            _c("label", { attrs: { for: "feedbackComment" } }, [
                              _vm._v(
                                "Was müsste anders sein, damit du mit der Seite zufriedener\n                  bist?"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.feedbackComment,
                                  expression: "feedbackComment",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { id: "feedbackComment", rows: "4" },
                              domProps: { value: _vm.feedbackComment },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.feedbackComment = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-primary",
                              on: { click: _vm.sendFeedback },
                            },
                            [
                              _vm._v(
                                "\n                Feedback abgeben\n              "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("aside", { staticClass: "sidebar" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          this.$messageHandling.hasError()
            ? _c(
                "div",
                {
                  staticClass: "alert alert-danger alert-dismissible fade show",
                  attrs: { role: "alert_error", id: "alert_error" },
                },
                [
                  _c("div", { staticClass: "d-flex" }, [
                    _c("div", [
                      _c("strong", [
                        _vm._v(_vm._s(this.$messageHandling.getErrorMessage())),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-auto" }, [
                      _c(
                        "span",
                        {
                          staticStyle: { cursor: "pointer" },
                          attrs: { "aria-hidden": "true" },
                          on: { click: _vm.hideError },
                        },
                        [_c("strong", [_vm._v("X")])]
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          this.$messageHandling.isSuccess()
            ? _c(
                "div",
                {
                  staticClass: "alert alert-info alert-dismissible fade show",
                  attrs: { role: "alert", id: "successfullLogin" },
                },
                [
                  _c("div", { staticClass: "d-flex" }, [
                    _c("div", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(this.$messageHandling.getSuccessMessage())
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-auto" }, [
                      _c(
                        "span",
                        {
                          staticStyle: { cursor: "pointer" },
                          attrs: { "aria-hidden": "true" },
                          on: { click: _vm.hideSuccess },
                        },
                        [_c("strong", [_vm._v("X")])]
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("router-view"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }